import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FamiliaFormGroup = ({ fIsSubmitting }) => (
  <Form.Group>
    <Form.Label text='FAMILIA' htmlFor='input-familia' md={4} alignRightAt='md' />
    <Col md={8}>
      <Field name='familia'>
        {({ field }) => <Form.InputText {...field} disabled={fIsSubmitting} id='input-familia' />}
      </Field>
    </Col>
  </Form.Group>
)

export default React.memo(FamiliaFormGroup)
